import * as React from "react";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import { LoginForm } from "./forms/login-form";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";

export interface IRecoveryLoginDialogProps {
    recoveryLoginAction: (username: string, password: string, onError: (err: any) => void) => void;
}

export class RecoveryLoginDialog extends React.Component<IRecoveryLoginDialogProps, any> {
    constructor(props: IRecoveryLoginDialogProps) {
        super(props);
    }
    render(): JSX.Element {
        return <Dialog
            open={true}
            aria-labelledby="responsive-dialog-title">
            <DialogTitle id="responsive-dialog-title">Session Expired</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Your session has expired. Sign in to continue from where you left off.
                </DialogContentText>
                <LoginForm loginAction={this.props.recoveryLoginAction} />
            </DialogContent>
        </Dialog>;
    }
}


// WEBPACK FOOTER //
// ./src/components/recovery-login-dialog.tsx